import FileGroup from './FileGroup'

export default FileGroup
